import { CLAN_MANAGEMENT_UPDATE } from 'state/actions/CMT/ClanManagement'
import * as actions from 'state/actions/CMT/MembersOperation'

const initialState = {
    selectedIds: [],
    selectedRole: null,
}

const _resetSelectedIds = (state) => ({
    ...state,
    selectedIds: [],
})

const reducerByAction = {
    [actions.UNTICK_CLAN_MEMBERS]: (state, action) => {
        const newSelected = state.selectedIds.filter(id => !action.memberIds.includes(id))
        return {
            ...state,
            selectedIds: newSelected,
        }
    },
    [actions.CLEAR_MEMBERS_OPERATION]: () => ({
        ...initialState,
    }),
    [actions.SELECT_ROLE_MEMBERS_OPERATION]: (state, action) => ({
        ...state,
        selectedRole: action.roleName,
    }),
    [actions.TOGGLE_ALL_MEMBERS_TICK]: (state, action) => {
        const selectedIds = state.selectedIds.length === action.memberIds.length ?
            [] : action.memberIds

        return {
            ...state,
            selectedIds,
        }
    },
    [actions.DIVIDE_PROFITS_SUCCESS]: _resetSelectedIds,
    [actions.CHANGE_ROLE_SUCCESS]: _resetSelectedIds,
    [actions.REMOVE_MEMBERS_SUCCESS]: _resetSelectedIds,
    [actions.RESET_SELECTED_MEMBERS]: _resetSelectedIds,
    [actions.TOGGLE_MEMBER_TICK]: (state, action) => {
        const selectedIds = state.selectedIds.filter(id => id !== action.memberId)
        if (selectedIds.length === state.selectedIds.length) {
            selectedIds.push(action.memberId)
        }
        return {
            ...state,
            selectedIds,
        }
    },
    [CLAN_MANAGEMENT_UPDATE]: (state, action) => {
        const newMemberIds = action.members.map(member => member.id)
        return {
            ...state,
            selectedIds: state.selectedIds.filter(id => newMemberIds.includes(id)),
        }
    },
}

export default (state = initialState, action) => {
    if (!action) return undefined
    const reducer = reducerByAction[action.type]

    if (!reducer) return state
    else return reducer(state, action)
}



// WEBPACK FOOTER //
// ./state/reducers/CMT/MembersOperation.js